import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { threadId } from 'worker_threads';
import { HostListener } from '@angular/core';
import { NativeGeocoderOptions, NativeGeocoder, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
import { Platform } from '@angular/cdk/platform';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';


@Component({
  selector: 'app-customer-service-booking',
  templateUrl: './customer-service-booking.component.html',
  styleUrls: ['./customer-service-booking.component.scss'],
})
export class CustomerServiceBookingComponent {
  brand;
  option;
  area;
  capacity;
  model;
  pay;
  colour;
  type;
  size;
  locateCheck:boolean=false;
  info:boolean=false;
  changeView:boolean=false;
  editShow:boolean=false;
  show:boolean=true;
  fDate;
  slots;
  dateFormat;
  promotions;
  promoObj;
  couponId;
  discountCoupon;
  payTotal;
  Id;
  optionName;
  optionId;
  // minDate = new Date();
  purchasedate:any;
  loader: boolean = true;
  active: boolean = true;
  editBool:boolean=false;
  activeInd: boolean = true;
  item:any;
  fontStyle;
  send:boolean=false;
  identificationNo;
  id;
  pic;
  cloneUsers:any=[];
  custName;
  category;
categoryName;
categoryId;
typeObj;
typeName;
typeId;
userId;
url;
typeObjAll;
Oid;users;
contactNbrMob;
itemCategoryId;
allServices:any=[];
services:any=[];
pacService:any=[];
serviceId;
serviceName;
startdate;
fdateCheck;
applicableDays;
applicableDaysName;
applicableDaysId;
allIndServices;
singleService;
daysObj=[{id:1,name:"Sunday"},
{id:2,name:"Monday"},
{id:3,name:"Tuesday"},
{id:4,name:"Wednesday"},
{id:5,name:"Thursday"},
{id:6,name:"Friday"},
{id:7,name:"Saturday"}];
dayType;
selectedDays:any=[];
date: any; 
buttonObj:any=[{name:"Individual House",flat:false,id:1},
{name:"Flat",flat:true,id:2}]
flatType = this.buttonObj[0].id;
appt:boolean = this.buttonObj[0].flat;
flatNo;
flatName;
custResItemObj:any=[];
custItemObj:any=[];
doorNbr;
custitem:any = [];
addItem:boolean=false;
plusBtn:boolean=true;
homeCleaning:boolean=false;
fridgeWashing:boolean=false;
acService:boolean=false;
custItemName;
subItemsType;
custItemId;
street;
subsId;
subscription;
cateId;
carService:boolean;
servId;
openItem:boolean=false;
categoryCode;
clicked:boolean=false;
head:boolean=false;
custReq:boolean=false;
addBtn:boolean=false;
serReq:boolean=false;
pricing:boolean=false;
typeCode;
itemTypeId;
minDate = new Date();
subType;
invoiceId;
time = "Time";
endTime;
availableSlots=[];
ItemsSelected:any=[];
availSlot:boolean;
slotClicked:boolean;
openSlot:boolean = false;
categoryIdCheck;
slot;
slotDate;
orderId;
orderItems:any;
defaultAddress;
regionchange:boolean=false;
changeDate:boolean = false;

  constructor(private service: ApiService,public handler: HandlerService,public router: Router,
    public auth: AuthService,  public location: LocationService,   public bottomSheet: MatBottomSheet,
    private loc: Geolocation,
    private platform:Platform,
    private geoCoder:NativeGeocoder,
    private LocationAccuracy: LocationAccuracy) { }

  ionViewWillEnter() {
    this.changeDate=false;
    this.location.pop=false;
    this.blockDate();
    this.Oid=localStorage.getItem('organizationId')
    this.dateFormat = this.auth.getDateformat();
    this.loader=true;  
    this.url = window.location.href;
    this.id = localStorage.getItem('currentUserId');
    // this.orderId = sessionStorage.getItem('orderId');
    this.orderId = localStorage.getItem('orderId');
    this.categoryCode = sessionStorage.getItem('cateCode')
    this.itemTypeId = sessionStorage.getItem('itemTypeId')
    this.brand = sessionStorage.getItem('make');
    this.model = sessionStorage.getItem('model');
    // this.itemTypeId = sessionStorage.getItem('itemType');  
    this.getUsers(); 
    // this.itemCategory();
  
    this.itemSubType();
    // this.getSingleService();
    // this.getdays(); 
    // this.getPromotions();  
    this.getOrder();
    this.blockDate();
    if(this.categoryCode =="PSC" || this.categoryCode =="HC" ||this.categoryCode=="CAR" ){
      this.info=true;
    }
    
    }
 

    getOrder() {
      this.service.getOrderByIdOri(this.orderId).subscribe((res: any) => {
      this.orderItems = res;
      if(res.custName){
        this.custName = res.custName;
      }
      if(res.apptDate){
        this.startdate = res.apptDate;
        var date1 = this.startdate.split("T");
        this.fDate = date1[0];
        this.slotDate = date1[0].split("-").reverse().join("-");
      }
      if(res.apptTime){
        this.time=res.apptTime;
        this.endTime=res.apptEndTime;
        this.changeDate = true;
      }
      this.categoryIdCheck=res.categoryId;
      this.location.regionId=res.delRegion; 
      this.location.cityId=res.delCity;
      this.location.stateId=res.delState;
      this.location.street = res.delStreet;
      this.location.zipcode =res.delZipcode;
      this.location.lat=res.lat;
      this.location.lon=res.lon;
      // this.location.latitude=res.latitude;
      // this.location.longtitude=res.longtitude;
      this.appt=res.appt;
      if(!this.appt){
        this.flatType = 1;
      }else{
        this.flatType = 2;
      }
      this.doorNbr=res.delDoorNbr;
      this.flatNo=res.flatNo;
      this.flatName=res.flatName;   

      this.ItemsSelected = res.itemOrders;
      if(this.categoryCode=="CAR"){
        this.carService=true;
      }
      if(this.categoryCode =="PSC" || this.categoryCode =="HC" ){              
        this.pricing=true;
        this.homeCleaning=true;
      }                                         
      this.itemType();
      console.log(this.location.cityId)
      })
      
    }

  

  itemCategory(){
    this.service.getOrgCategory().subscribe(res=>{
      this.category = res;    
        if (this.category.length > 0) {
          this.category.map(res1 => {
            if (res1.id == this.cateId ) {         
              this.categoryName = res1.name;
              this.categoryId = res1.id;
              this.categoryCode = res1.code;
              
              if(this.categoryCode=="CAR"){
                this.carService=true;
              }
              if(this.categoryCode =="PSC" || this.categoryCode =="HC" ){              
                this.pricing=true;
                this.homeCleaning=true;
              }                                                         
            }
            }) 
      }
      this.getUsers();
     })
  }

  itemSubType(){
    this.service.getSubItemType().subscribe(res=>{
      this.subType=res;
  
    })
  }

  itemType(){
    this.service.getItemTypeByCategory(this.categoryIdCheck).subscribe(res=>{
    
      this.typeObjAll = res; 
      if (this.typeObjAll.length > 0) {
        this.typeObjAll.map(res1 => {
          if (res1.id == this.itemTypeId ) {           
            this.typeName = res1.name;
            this.typeId = res1.id;
            this.typeCode= res1.code;
            this.location.typeId=res1.id;
            if(this.typeCode=="AC"){
              this.fridgeWashing=true;
              this.acService=true;
            }   
            if(this.typeCode=="RF" || this.typeCode=="WM"){
              this.fridgeWashing=true;
            }
            if(this.typeCode=="HO"){
              this.homeCleaning=true;
            } 

          }
          }) 
    } 
    })
  }

  addCustItem(){
    if(this.custitem.length>0){
    this.custitem.map(res=>{
      if(res.clicked){
        res.clicked=false
       }
      })
    }
    this.addItem = true;
    this.custReq=false;
    this.serReq=true;
    this.custItemId = "";
  }

  getdays(){   
    this.service.getApplicableDays().subscribe((res:any)=>{
      this.applicableDays=res;      
    }) 
  }

  
//   openBottomSheetDays(): void { 
//     const dialogRef = this.bottomSheet.open(BottomSheet, {
//      data:this.applicableDays,
//    });
//    dialogRef.afterDismissed().subscribe((res) => {
//      this.applicableDaysName = res.name;
//      this.applicableDaysId = res.id;
//      });
//  }


 openBottomSheetsubType(): void{
   this.subItemsType=this.subType.filter(res=> res.itemTypeId==this.itemTypeId)
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data:this.subItemsType,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    this.optionName = res.name;
    this.optionId = res.id;
    });
 }

 getCost(){
    if(    this.itemTypeId != undefined && this.location.regionId != undefined &&this.servId != undefined &&
      this.itemTypeId!= "" && this.location.regionId != "" &&this.servId  != ""){
        var data={
          "itemTypeId":  this.itemTypeId,
          "region": this.location.regionId,
          "serviceId":this.servId  
        }
        this.service.getCost(data).subscribe((res:any)=>{
          if(res!=null){
            this.location.markedPrice = res[0].cost;
          }else{
            this.handler.error("Please Select Different Location");
            this.location.markedPrice = "";
          }
        }, err => {
          this.handler.err(err);
        })
      }
 }

 savedItems(){
   this.openItem = true;
   if(this.custitem == ""){
    this.handler.res("No Saved Items For You");
   }
 }

  getUsers(){  
    this.service.getUserById(this.id).subscribe((res:any) => {    
      this.users = res; 
      this.custItemObj=this.users.custItems;   
      this.custitem=this.custItemObj.filter(res =>res.itemCategoryId ==  this.cateId && res.make != "XXX");
      this.custName = this.users.firstName;
      this.contactNbrMob = this.users.contactNbrMob;
      // if(this.users.addresses[0]){
      // this.location.regionId=this.users.addresses[0].regionId;
      // this.location.street=this.users.addresses[0].street;
      // this.location.stateId=this.users.addresses[0].stateId;
      // this.location.cityId=this.users.addresses[0].cityId;
      // this.location.zipcode=this.users.addresses[0].zipcode; 
      // this.appt=this.users.addresses[0].appt;
      // if(!this.appt){
      //   this.flatType = 1;
      // }else{
      //   this.flatType = 2;
      // }
      // this.doorNbr=this.users.addresses[0].doorNbr;
      // this.flatName=this.users.addresses[0].flatName;
      // this.flatNo=this.users.addresses[0].flatNo;
        
      // } 
      this.loader=false;  
     
      this.getCost();
      },err=>{
        this.handler.err(err)
        this.loader = false;
      }) 
   
  }

  getUsersAdrs(){  
    this.service.getUserById(this.id).subscribe((res:any) => {    
      this.users = res; 
     if(this.users.addresses[0]){
      this.location.regionId=this.users.addresses[0].regionId;
      this.location.street=this.users.addresses[0].street;
      this.location.stateId=this.users.addresses[0].stateId;
      this.location.cityId=this.users.addresses[0].cityId;
      this.location.zipcode=this.users.addresses[0].zipcode; 
      this.location.lat=this.users.addresses[0].lat;
      this.location.lon=this.users.addresses[0].lon;
      // this.location.latitude=this.users.addresses[0].latitude;
      // this.location.longtitude=this.users.addresses[0].londtitude;
      this.appt=this.users.addresses[0].appt;
      if(!this.appt){
        this.flatType = 1;
      }else{
        this.flatType = 2;
      }
      this.doorNbr=this.users.addresses[0].doorNbr;
   
      this.flatName=this.users.addresses[0].flatName;
      this.flatNo=this.users.addresses[0].flatNo;
      this.loader=false;     
      } 
     
     
      this.getCost();
      },err=>{
        this.handler.err(err)
        this.loader = false;
      }) 
   
  }

  onInput() {
    this.location.serviceArea = true;
    this.location.autoComplete();
  }

  sendId(data,id){
    data.clicked = ! data.clicked;
    this.custitem.map(res=>{if(id!=res.id){
      res.clicked=false;
    }
    })
    this.custItemId = id;
    let x=this.custitem.find(res=>res.clicked);
    if(!x){   
      this.custItemId ="";
    }
    this.location.typeId = data.type;
    this.location.houseNbr=data.houseNbr;
    this.location.cityId=data.cityId;
    this.location.stateId=data.stateId;
    this.location.street=data.street;
    this.location.regionId=data.regionId;
    this.location.zipcode=data.zipcode;
    this.location.lat=data.lat;
    this.location.lon=data.lon;
    // this.location.latitude=data.latitude;
    // this.location.longtitude=data.longtitude;
    this.appt=data.appt;
    this.doorNbr=data.doorNbr;
    this.flatNo=data.flatNo;
    this.flatName=data.flatName;
    this.custReq=true;
    this.serReq=false;
  }

  createCustItem() {
    if(this.custItemId){
      this.create();
    }
  else{
    this.loader = true;
    if(!this.brand){
      this.brand="XXX";
    }
    if(!this.model){
      this.model="XXX";
    }
    if(!this.colour){
      this.colour="XXX";
    }
    if(!this.identificationNo){
      this.identificationNo="TN00A0000"
    }

    var post={
      "make": this.brand,
      "model": this.model,
      "type": this.typeId,   
      "custName":this.custName,
      "contactNbrMob":this.contactNbrMob,
      "itemCategoryId":this.categoryId,
      "subItemTypeId":this.optionId,
      "capacity":this.capacity,
      "area":this.area,
      "userId":this.id,
      "identificationNo":this.identificationNo,
      "activeInd": true,
      "colour":this.colour, 
      "appt":this.appt,
      "houseNbr": this.location.houseNbr,
      "cityId": this.location.cityId,
      "stateId": this.location.stateId,
      "regionId":this.location.regionId,
      "zipcode":this.location.zipcode,
      "lat": this.location.lat,
      "lon": this.location.lon,
      // "latitude":this.location.latitude,
      // "longtitude":this.location.longtitude,
    } 
    if(!this.appt){
      Object.assign(post,{"doorNbr":this.doorNbr,"street": this.location.street})
    }else{
      Object.assign(post,{"flatNo":this.flatNo, "flatName":this.flatName,})
    }
    this.service.custItem(post).subscribe(res=>{  
      this.custResItemObj = res; 
      this.custItemId=this.custResItemObj.id; 
      this. create();
      this.loader = false;   
   
    },
    err=>{
      this.loader=false;
      this.handler.err(err);
    })
  }
  
  }

    create() {
      this.loader = true;
      if(!this.Id){
        this.payTotal=this.location.markedPrice;
      }
       var post={   
        "custName":this.custName,
        "contactNbrMob":this.contactNbrMob,
        "custItemId":this.custItemId,
        "categoryId":this.categoryId,     
        "providerServiceId":this.serviceId,     
        "activeInd": true,
        "serviceProviderId":localStorage.getItem('organizationId'),
        "document":this.pic,
        "cost":this.location.markedPrice,
        "payTotal":this.payTotal,    
        "packageInd":false,
        "subscriptionInd":false,
        "requestorId":this.id,
        "apptDate": this.fDate,  
        "apptTime":this.time,
        "apptEndTime": this.slot.endTime,  
        "type":1,
        "status": 1,
        "requestDates": [
          {
            "apptDate": this.fDate,  
            "apptTime":this.time,
            "apptEndTime": this.slot.endTime,        
            "status": 1
          }],
        "address":{
          "houseNbr": this.location.houseNbr,
          "cityId": this.location.cityId,
          "stateId": this.location.stateId,
          "regionId":this.location.regionId,
          "zipcode":this.location.zipcode,
          "lat": this.location.lat,
          "lon": this.location.lon,
          // "latitude":this.location.latitude,
          // "longtitude":this.location.longtitude,
          "type": 1,
          "appt":this.appt
        }      
      
      } 
      if(!this.appt){
        Object.assign(post.address,{"doorNbr":this.doorNbr,"street": this.location.street})
      }else{
        Object.assign(post.address,{"flatNo":this.flatNo, "flatName":this.flatName,})
      }     
           this.service.createSingleReq(post).subscribe((res:any)=>{          
          this.invoiceId = res.customerInvoiceId;
          sessionStorage.setItem('requestId', res.id)
          this.handler.res("Request Created Successfully");
        this.loader = false;
        this.brand=undefined;      
          this.router.navigate(['invoice/', +this.invoiceId])  
  
      },
      err=>{
        this.loader=false;
        this.handler.err(err);
      })
    }

    update(){
      // this.loader = true;
      var locateTrue  = localStorage.getItem('locationTrue');
      if(locateTrue == 'true'){
        this.UpdateService();
      }else{
        this.handler.error('Selected service is not provided in this region!!! Please select different region');
        this.loader = false
      }
    }

    
    UpdateService(){
        //  this.loader = true;
         if (this.changeDate){
          Object.assign(this.orderItems,{"type": 1,
          "appt":this.appt,
          "capacityDefId":  '1',
          "custName"  :this.custName,
          "custContactNbrMob":this.contactNbrMob,
          "apptTime": this.time,
          "apptDate": this.fDate,
          "apptStartTime":this.time,   
          "apptEndTime":  this.endTime,
          "cnvcChargeApplied":true,
          "requestDates": [
            {
                "apptDate": this.fDate,
                "apptTime":  this.time,  
                "apptEndTime":  this.endTime ,         
                "status": 1
            }]})
            if(!this.appt){
             Object.assign(this.orderItems,{"delDoorNbr":this.doorNbr,"delStreet": this.location.street, "delCity": this.location.cityId,
             "delState":this.location.stateId,
             "lat":this.location.lat,
             "lon":this.location.lon,
            //  "latitude":this.location.latitude,
            //  "longtitude":this.location.longtitude,
             "delRegion":this.location.regionId})
           }else{
             Object.assign(this.orderItems,{"flatNo":this.flatNo, "flatName":this.flatName,"delCity": this.location.cityId,
             "delState":this.location.stateId,
             "lat":this.location.lat,
             "lon":this.location.lon,
            //  "latitude":this.location.latitude,
            //  "longtitude":this.location.longtitude,
             "delRegion":this.location.regionId})
           }
           if(this.regionchange){
             Object.assign(this.orderItems,{"region":this.location.regionId,"delCity": this.location.cityId,
             "delState":this.location.stateId,
             "lat":this.location.lat,
             "lon":this.location.lon,
            //  "latitude":this.location.latitude,
            //  "longtitude":this.location.longtitude,
             "delRegion":this.location.regionId})
           }
           
      this.service.updateOrder(this.orderId,this.orderItems).subscribe((res:any) =>{   
        let url=window.location.href
        if(this.regionchange){
          sessionStorage.setItem('region',this.location.regionId);
         this.handler.res('Cost Updated Successfully , based on region!!')
         this.getOrder();
         this.regionchange = false
         this.changeView = true;
        }
         else{
         // this.handler.res('Booked Successfully !!')
         this.router.navigate(['review-items'])
         }     
        this.loader = false;
      },err => {
        this.loader = false;
        this.handler.err(err)
      })
         }else{
          this.loader = false;
          this.handler.err('Please Enter Required Fields')
         }
     
     }
     
    getSingleService(){
      this.service.getAllItems().subscribe((res: any) => {
     this.allServices=res;   
     if (this.allServices.length > 0) {
      this.allServices.map(res1 => {
        if (res1.id == this.servId ) {
          this.serviceName = res1.name;
          this.serviceId = res1.id;
          this.location.subscriptionId = res1.id;
        }
        }) 
  }
    
    })
 }

 cancel(){
  this.router.navigate(['edit-services'])

 }

 getAppt(id){
  this.appt = id;
} 
   
  
    ionViewWillLeave(){
      this.fDate = "";
      this.slotDate = "";
      this.brand="";
      this.model="";
      this.custName="";
      this.contactNbrMob="";
      this.categoryName="";
      this.typeName="";
      this.typeId="";
      this.categoryId="";
      this.serviceName="";
      this.identificationNo="";      
      this.location.markedPrice="";
      this.doorNbr="";
      this.location.typeId="";
      this.location.subscriptionId = "";
       this.location.pop=false;
      this.location.newSearch="";                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
      sessionStorage.removeItem('cateId')  
      sessionStorage.removeItem('itemType')
      sessionStorage.removeItem('itemId')
      this.regionchange = false;
      this.changeView = false;
      this.time="Time";
      this.dateFormat="";
      this.colour="";
      this.startdate = "";
    }

    userDetails(data){
      this.contactNbrMob =data.contactNbrMob;
      // this.userId = data.userId;
   
    }


  //  getUser(val) { 
  //   let x = val.length;
  //   if(x > 0){
  //     this.service.searchCustomers("CUST",val,this.Oid).subscribe((res: any) => {
  //       this.cloneUsers =JSON.parse(JSON.stringify(res)); 
  //     })
  //   }
  //   }

    // openBottomSheet(): void {
    //   if(this.custItemId==null){
    //   const dialogRef = this.bottomSheet.open(BottomSheet,{
    //     data: this.category,
    //   });
    //   dialogRef.afterDismissed().subscribe((res:any) => {
    //     if(res){
    //       this.categoryName = res.name;
    //       this.categoryId=res.id;  
    //       if(this.url.includes("single-request") || this.url.includes('single-requests') || this.url.includes('req-booking')){
    //         this.custitem=this.custItemObj.filter(res =>res.itemCategoryId == this.categoryId);
    //         this.custitem.every(res=>Object.assign(res,{clicked:false}));
    //         this.head=true;  
    //         this.addBtn=true;
    //        }    
          
    //       }     
        
    //   });
    // }
    // }

    // openBottomSheet1(): void {
    //   if(this.categoryCode=="CAR"){
    //     this.typeObj=this.typeObjAll.filter(res=> res.itemCategory==this.cateId)   
    //     const dialogRef = this.bottomSheet.open(BottomSheet,{
    //       data: this.typeObj,
    //     });
    //     dialogRef.afterDismissed().subscribe((res:any) => {
    //       if(res){
    //         this.typeName = res.name;
    //         this.typeId=res.id;
    //         this.location.typeId=res.id;
    //         if(this.location.typeId != undefined && this.location.regionId != undefined &&this.location.subscriptionId != undefined &&
    //           this.location.typeId != "" && this.location.regionId != "" &&this.location.subscriptionId != ""){
    //             var data={
    //               "itemTypeId": this.location.typeId,
    //               "region": this.location.regionId,
    //               "serviceId":this.location.subscriptionId 
    //             }
    //             this.service.getCost(data).subscribe((res:any)=>{
    //               if(res!=null){
    //                 this.location.markedPrice = res[0].cost;
    //               }else{
    //                 this.handler.error("Please Select Different Location");
    //                 this.location.markedPrice = "";
    //               }
    //             }, err => {
    //               this.handler.err(err);
    //             })
    //         }
    //       }
    //     });
      
    //   } 
     
    // }

    switchDayType(val){
      let a=this.selectedDays.filter(res=>res.id==val);
      if(a.length>0){
        var b = a[0].id
      }
      if(b==undefined){
        let check=this.daysObj.find(res=>{return res.id==val})
        if(check){
          this.selectedDays.push({id:check.id,name:check.name})
        }
      }else{
        this.handler.res("Day Already Added")
      }
    }


    removeChip(i) {
      this.selectedDays.splice(i, 1);
    }


    
    handleFile(files) {
        var img = new Image();
        img.src = URL.createObjectURL(files[0]);
        img.onload = (data) => {
          var canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          this.pic = canvas.toDataURL('image/jpeg', 1.5);
        }
    }

    returnDate(data) {
      let date = data.getDate();
      date = date < 10 ? '0' + date : date;
     let month = data.getMonth() + 1;
     month = month < 10 ? '0' + month : month;
     let year = data.getFullYear();  
     return year + '-' + month + '-' + date;
   }

   returnDate1(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
   let month = data.getMonth() + 1;
   month = month < 10 ? '0' + month : month;
   let year = data.getFullYear();  
   return date + '-' + month + '-' + year;
 }

   startDate(){
      this.fDate=this.returnDate(this.startdate);
      this.slotDate=this.returnDate1(this.startdate);
      this.time = "Time"
    }

    checkPreview(){
      this.openSlot = true;
      this.slotClicked =false;
      var post ={
        "targetCenterId": this.Oid,
        "targetSource": this.Oid,
        "schElements": [
            1
        ],
        "requestDate": this.fDate,
        "status": [
            "SlotsAvailable"
        ],
        "independentEntities": true,
        "slotDuration": 15
    }
      this.service.getTimeSlots(this.slotDate,post).subscribe((res: any) => {
        if (res){
          this.availableSlots = res;
          this.availSlot = true;
          this.slotClicked = true;
        }else{
           this.handler.res("No Available Slots");
           this.availSlot = false;
           this.slotClicked = true;
        }
        
      },err=>{
        this.availSlot = false;
        this.slotClicked = true;
      })
    }

    setTime(data){
      this.time = data.startTime;
      this.endTime = data.endTime;
      this.slot = data;
      this.slotClicked = false;
      this.openSlot = false;
      this.changeDate = true;
    }

    blockDate(){
      // Block From Date
      var someDate = new Date();
      var numberOfFromDaysToAdd = 1;
      someDate.setDate(someDate.getDate() + numberOfFromDaysToAdd); 
      var dd = someDate.getDate();
      var mm = someDate.getMonth() + 1;
      var month = mm-1;
      var y = someDate.getFullYear();
      this.fdateCheck = new Date(y, month, dd)
    }

  
    getPromotions(){
      this.service.getServiceCoupon(this.Oid).subscribe(res=>{
        this.promotions = res;
      })
    }
       
         
    // openBottomSheetDiscount(): void {
    //   this.promoObj = this.promotions.filter(res=>{ return res.id == this.couponId});
    //   const dialogRef = this.bottomSheet.open(BottomSheet,{
    //     data: this.promoObj,
    //   });
    //   dialogRef.afterDismissed().subscribe((res) => {
    //     this.discountCoupon = res.name;
    //     this.Id=res.id;
    //     this.getpayTotal();
    //   });
    // }

    getpayTotal(){
      this.loader = true;
      var post={
        "cost":this.location.markedPrice,
        "discountCoupon":this.discountCoupon
      }
      this.service.getPayTotal(post).subscribe((res:any)=>{
      if(res){     
        this.payTotal = res.payTotal;
        this.send=true;
        this.loader = false;
      }else{
        this.loader=false;
        this.handler.err('Enter Valid Discount Coupen')
      }
    },err =>{
      this.loader = false;
      this.handler.err("err");   
      
      })
    }

    editCost(){
      this.show=false;
      this.editShow=true;
    
    }

    popClose(){
      this.location.pop=false;
      this.location.newSearch="";
      this.location.dummy = false;
      this.regionchange = false;
    }

    locationpop(){
      this.doorNbr="";
      this.location.openPop();
      this.regionchange = true;
      // this.getUsersAdrs();
    }
   
    open(){
      this.addItem=true;
      this.plusBtn = false;
    }

    close(){
      this.addItem=false;
      this.plusBtn = true;  
    }
      
  openLocation(){
    // this.location.lat="";
    // this.location.lon="";
    //  this.location.zipcode="";
    //  this.location.street="";
    //  this.location.stateId="";
    //  this.location.cityId="";
    //  this.location.regionId="";
    this.askToTurnOnGPS();  
    // this.location.pop = false;
  }

  askToTurnOnGPS() {
    this.locateCheck=true;
    this.LocationAccuracy.request(this.LocationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
      () => {
        this.setLoc()
      },
      error =>{
      alert('Device location access is required to fetch your current location')
     this.locateCheck=false;
    }  
    );
  }

  setLoc(){
    if(this.platform.ANDROID || this.platform.IOS){
      this.locateCheck=true;
      this.loader=true;
        let options: NativeGeocoderOptions = { useLocale: true,maxResults: 1 };
      this.loc.getCurrentPosition().then(res => {
        this.geoCoder.reverseGeocode(res.coords.latitude, res.coords.longitude, options).then((result: NativeGeocoderResult[]) => {
          this.loader = false; 
          this.handler.deny = 0;    
          localStorage.removeItem('deny');
          let x: any = result;
            localStorage.setItem('location', JSON.stringify(x));
            let loc;
            loc=JSON.parse(localStorage.getItem('location'));
            this.location.lat=loc[0].latitude;
            this.location.lon=loc[0].longitude;
            // this.location.latitude=loc[0].latitude;
            // this.location.longtitude=loc[0].longitude;
             this.location.zipcode=loc[0].postalCode;
             this.location.street=loc[0].thoroughfare;
             this.location.stateId=loc[0].administrativeArea;
             if(loc[0].locality){
              this.location.cityId=loc[0].locality; 
             }else{
              this.location.cityId=loc[0].subAdministrativeArea; 
             }
             if(loc[0].subLocality){
              this.location.regionId=loc[0].subLocality;
             }else{
              this.location.regionId=loc[0].neighborhood;
             }
             this.getLocationDetails(this.location.cityId); 
             this.location.pop = false;  
             this.locateCheck=false;  
        },
        err=>{
          this.locateCheck=false;
          this.loader = false;
          this.location.pop = false;
          this.handler.err(err);
        })        
    },
    err=>{
      this.handler.deny++;
      if(this.handler.deny > 2 && !localStorage.getItem('deny')){
        this.handler.staticError("Please turn on location access permission for App,from Settings");
        localStorage.setItem("deny" , "1");
      }
      if(localStorage.getItem('deny')){
        this.handler.staticError("Please turn on location access permission for App,from Settings");
      }
      this.loader = false;
      this.locateCheck=false;
      this.handler.err(err);
    })
this.location.serviceArea = true;

 }   
}

getLocationDetails(data){
  console.log(data)
  if(this.location.cityId=="Chennai" || this.location.cityId=="chennai" || this.location.cityId=="CHENNAI" || 
  this.location.cityId=="Thiruvallur" ||this.location.cityId=="thiruvallur"|| this.location.cityId=="THIRUVALLUR" ||
  this.location.cityId=="Tiruvallur" ||this.location.cityId=="tiruvallur"|| this.location.cityId=="TIRUVALLUR"){
  var post={
    "id":790,
    "city":data
  }
  this.service.locationSearch(post).subscribe((res:any)=>{
    if(res !=null || res=="OK"){
      this.location.locationTrue=true;
      localStorage.setItem('locationTrue', 'true');
    }else{
      this.location.locationTrue=false;
      localStorage.setItem('locationTrue', 'false');
      this.handler.err('Selected service is not provided in this region!!! Please select different region');
    }
  },err =>{
    this.location.locationTrue=false;
    localStorage.setItem('locationTrue', 'false');
    this.handler.err(err);
  })
}else{
  var post1={
    "id":790,
    "region":data
  }
  this.service.locationSearch(post1).subscribe((res:any)=>{
    if(res !=null){
      this.location.locationTrue=true;
      localStorage.setItem('locationTrue', 'true');
    }else{
      this.location.locationTrue=false;
      localStorage.setItem('locationTrue', 'false');
      this.handler.err('Selected service is not provided in this region!!! Please select different region');
    }
  },err =>{
    this.location.locationTrue=false;
    localStorage.setItem('locationTrue', 'false');
    this.handler.err(err);
  })
}
}



}